import { Box } from "@twilio-paste/core/box";
import { useTheme } from "@twilio-paste/theme";
import React from "react";
import FooterBuildingBlocks from "../../../assets/icons/footer-building-blocks.svg";

const SiteFooterIllustration: React.FC = () => {
    const theme = useTheme();
    return (
        <Box
            bottom={-6}
            display={["none", "none", "none", "block"]}
            right={theme.sizes.sizeSquare120}
            position="absolute"
        >
            <FooterBuildingBlocks aria-hidden="true" role="img" />
        </Box>
    );
};

export { SiteFooterIllustration };
